/* tslint:disable */
/* eslint-disable */
export enum WorkChangeSourceEnum {
  MissingInitialAgreement = 'MISSING_INITIAL_AGREEMENT',
  External = 'EXTERNAL'
}
